import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const Whistle = ({ fill = 'gcBlue', size = 'xsmall', height, width, className }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={width ?? IconSizes[size]}
            height={height ?? IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5 9C10.1569 9 11.5 10.3431 11.5 12C11.5 13.6569 10.1569 15 8.5 15C6.84315 15 5.5 13.6569 5.5 12C5.5 10.3431 6.84315 9 8.5 9ZM8.5 11C7.94772 11 7.5 11.4477 7.5 12C7.5 12.5523 7.94772 13 8.5 13C9.05228 13 9.5 12.5523 9.5 12C9.5 11.4477 9.05228 11 8.5 11Z"
                className={fillStyles}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.5 5C21.1569 5 22.5 6.34315 22.5 8V10C22.5 11.6569 21.1569 13 19.5 13H15.4277L15.4004 13.1816C14.8518 16.4081 12.0953 18.8827 8.74023 18.9961L8.5 19C4.63401 19 1.5 15.866 1.5 12C1.5 8.13401 4.63401 5 8.5 5H19.5ZM8.29395 7C5.37016 7.00009 3.5 9.23863 3.5 12C3.5 14.7614 5.37016 16.9999 8.29395 17C11.2178 17 13.5879 14.7614 13.5879 12C13.5879 11.4477 14.0627 11 14.6475 11H19.9414C20.5261 10.9999 21 10.5522 21 10V8C21 7.44779 20.5261 7.00012 19.9414 7H15.5V8C15.5 8.55228 15.0523 9 14.5 9C13.9477 9 13.5 8.55228 13.5 8V7H8.29395Z"
                className={fillStyles}
            />
        </svg>
    );
};
